import * as Yup from 'yup'

export default Yup.object({
  messageType: Yup.number().nullable().oneOf([4, 5, 6, 7], '入力必須です。'),
  freeMessage: Yup.string().nullable()
    .required('入力必須です。')
    .test('freeMessage', '入力必須です。', (value) => {
      return Boolean(String(value).replace(/\s+/g, ''))
    })
    .max(4000, '4000文字以下で入力してください。'),
  type: Yup.number().nullable().oneOf([2, 4, 5, 6, 7], '入力必須です。'),
  message: Yup.string().nullable()
    .max(4000, '4000文字以下で入力してください。')
    .when('messageType', {
      is: (messageType) =>
        messageType !== 7,
      then: Yup.string().test('message', '入力必須です。', (value) => {
        return Boolean(String(value).replace(/\s+/g, ''))
      }).required('入力必須です。'),
    }),
})
